// extracted by css-extract-rspack-plugin
export default {"contentWrapper":"index__contentWrapper___GPsL5","title":"index__title___rip7O","titleWrapper":"index__titleWrapper___ISJG3"};